import React from 'react';
import { Route } from 'react-router-dom';
import { LayoutRoute } from './LayoutRoute';
import { NonVendorRoute, ProtectedRoute } from './RouteWrappers';
import { PageLoader, RootRoute } from './standaloneRouteHelpers';
import {
  AddProperty,
  AnalyticsDashboard,
  AuthLandingPage,
  CompanyOnboarding,
  ConciergeDashboardPage,
  DocumentVaultPage,
  EmergencyPlanBuilderPage,
  EmergencyPlans,
  EmergencyPlanView,
  EmergencyResponse,
  FirstResponder,
  KioskPreview,
  MaintenanceAuth,
  MaintenanceDashboard,
  MaintenanceTeam,
  OperationsCenter,
  Properties,
  PropertyView,
  TenantApp,
  TenantAuth,
  TenantEngagement,
  VendorAuth,
  VendorCompanyPortal,
  VendorDashboard,
  VendorDispatchPage,
  VendorManagementPage,
  VendorOnboarding,
  Vendors,
  VendorShieldPro,
  VendorShieldProAuth,
  VendorTech,
  VendorTechAuth,
  WorkOrders,
} from './standaloneRoutePages';

export const RootAndStandaloneRoutes = () => (
  <>
    <Route path="/" element={<RootRoute />} />
    <Route path="/vendor-tech" element={<PageLoader><VendorTech /></PageLoader>} />
    <Route path="/vendor-dashboard" element={<PageLoader><VendorDashboard /></PageLoader>} />
    <Route path="/maintenance-team" element={<PageLoader><MaintenanceTeam /></PageLoader>} />
    <Route path="/vendor-auth" element={<PageLoader><VendorAuth /></PageLoader>} />
    <Route path="/maintenance-auth" element={<PageLoader><MaintenanceAuth /></PageLoader>} />
    <Route path="/vendor-tech-auth" element={<PageLoader><VendorTechAuth /></PageLoader>} />
    <Route path="/vendorshield-pro-auth" element={<PageLoader><VendorShieldProAuth /></PageLoader>} />
    <Route path="/tenant-auth" element={<PageLoader><TenantAuth /></PageLoader>} />
    <Route path="/landing" element={<PageLoader><AuthLandingPage onLogin={() => {}} /></PageLoader>} />
    <Route
      path="/onboarding"
      element={
        <ProtectedRoute>
          <PageLoader><CompanyOnboarding /></PageLoader>
        </ProtectedRoute>
      }
    />
  </>
);

export const CoreRoutes = () => (
  <>
    <Route
      path="/operations"
      element={
        <LayoutRoute>
          <NonVendorRoute>
            <PageLoader><OperationsCenter /></PageLoader>
          </NonVendorRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/analytics"
      element={
        <LayoutRoute>
          <NonVendorRoute>
            <PageLoader><AnalyticsDashboard /></PageLoader>
          </NonVendorRoute>
        </LayoutRoute>
      }
    />
  </>
);

export const PropertyRoutes = () => (
  <>
    <Route
      path="/properties"
      element={
        <LayoutRoute>
          <NonVendorRoute>
            <PageLoader><Properties /></PageLoader>
          </NonVendorRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/properties/add"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><AddProperty /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/properties/:id"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><PropertyView /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/properties/:propertyId/documents"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><DocumentVaultPage /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
  </>
);

export const VendorRoutes = () => (
  <>
    <Route
      path="/vendor-dispatch"
      element={
        <NonVendorRoute>
          <PageLoader><VendorDispatchPage /></PageLoader>
        </NonVendorRoute>
      }
    />
    <Route
      path="/vendorshield-pro"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><VendorShieldPro /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/vendors"
      element={
        <LayoutRoute>
          <NonVendorRoute>
            <PageLoader><Vendors /></PageLoader>
          </NonVendorRoute>
        </LayoutRoute>
      }
    />
    <Route path="/vendor-management" element={<PageLoader><VendorCompanyPortal /></PageLoader>} />
    <Route path="/vendor-onboarding" element={<PageLoader><VendorOnboarding /></PageLoader>} />
    <Route
      path="/vendor-directory"
      element={
        <LayoutRoute>
          <NonVendorRoute>
            <PageLoader><VendorManagementPage /></PageLoader>
          </NonVendorRoute>
        </LayoutRoute>
      }
    />
  </>
);

export const MaintenanceRoutes = () => (
  <>
    <Route
      path="/maintenance"
      element={
        <LayoutRoute>
          <NonVendorRoute>
            <PageLoader><WorkOrders /></PageLoader>
          </NonVendorRoute>
        </LayoutRoute>
      }
    />
    <Route path="/maintenance-dashboard" element={<PageLoader><MaintenanceDashboard /></PageLoader>} />
    <Route
      path="/work-orders"
      element={
        <LayoutRoute>
          <NonVendorRoute>
            <PageLoader><WorkOrders /></PageLoader>
          </NonVendorRoute>
        </LayoutRoute>
      }
    />
  </>
);

export const EmergencyRoutes = () => (
  <>
    <Route
      path="/emergency-plans"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><EmergencyPlans /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/emergency-plans/:id"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><EmergencyPlanView /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/emergency-response"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><EmergencyResponse /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/emergency-plan-builder"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><EmergencyPlanBuilderPage /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route path="/first-responder" element={<PageLoader><FirstResponder /></PageLoader>} />
  </>
);

export const TenantRoutes = () => (
  <>
    <Route path="/tenant" element={<PageLoader><TenantApp /></PageLoader>} />
    <Route
      path="/tenant-engagement"
      element={
        <LayoutRoute>
          <NonVendorRoute>
            <PageLoader><TenantEngagement /></PageLoader>
          </NonVendorRoute>
        </LayoutRoute>
      }
    />
    <Route path="/kiosk-preview" element={<PageLoader><KioskPreview /></PageLoader>} />
    <Route
      path="/concierge-dashboard"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><ConciergeDashboardPage /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
  </>
);
